/**
 * Maps a clinic from POST /v1/clinics/search to the shape ClinicsList expects.
 */
export const mapClinicSearchItem = (clinic) => ({
  _id: clinic.id,
  clinic: clinic.label,
  address: clinic.address ?? '',
  isAvailable: clinic.isAvailable ?? clinic.is_available ?? true,
  distance: clinic.distance ?? null
})

export const isClinicsSearchSuccess = (response) => response?.code === 0

export const mapClinicsSearchResponse = (response) =>
  (response?.data?.clinics ?? []).map(mapClinicSearchItem)
